import type { FunctionComponent } from 'react';
import React from 'react';

/**
 * Car & Apartment Icon - Used in shopfor page
 */
export const CarAptIcon: FunctionComponent<unknown> = () => {
  return (
    <svg width="34" height="18" viewBox="0 0 34 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 11.5H12.5" stroke="#0D202F" strokeMiterlimit="10" />
      <path
        d="M14.5 15.5H16V11.5H12.5L10.5 8H4.5L3 11.5H1V15.5H2.5"
        stroke="#0D202F"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M5.5 15.5H11.5" stroke="#0D202F" strokeMiterlimit="10" strokeLinecap="square" />
      <path
        d="M4 17C4.82843 17 5.5 16.3284 5.5 15.5C5.5 14.6716 4.82843 14 4 14C3.17157 14 2.5 14.6716 2.5 15.5C2.5 16.3284 3.17157 17 4 17Z"
        stroke="#0D202F"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M13 17C13.8284 17 14.5 16.3284 14.5 15.5C14.5 14.6716 13.8284 14 13 14C12.1716 14 11.5 14.6716 11.5 15.5C11.5 16.3284 12.1716 17 13 17Z"
        stroke="#0D202F"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M7.5 8V11.5" stroke="#0D202F" strokeMiterlimit="10" />
      <path d="M20.5 15.5H18.9M16.5 9H20.5" stroke="#FF3975" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M23 11H24.5" stroke="#FF3975" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M23 13H24.5" stroke="#FF3975" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M23 9H24.5" stroke="#FF3975" strokeMiterlimit="10" strokeLinecap="square" />
      <path
        d="M26 4.5V1L33 3.5V15.5H20.5V6.5H27V15.3335"
        stroke="#FF3975"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M29 13V4.5" stroke="#FF3975" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M31 13V5.5" stroke="#FF3975" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  );
};
